var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import axios from 'axios';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';
import { axiosClient } from '@app/configure-app';
import { ActivityIndicator } from '@atomic';
import { desenharMarcaDagua } from './document-watermark';
// O worker é copiado para a raiz do bundle pelo CopyWebpackPlugin.
pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';
// Proporção de uma folha A4, usada enquanto a página ainda não foi desenhada.
var PROPORCAO_PAGINA = 1.414;
var MARGEM_PRE_CARGA = '300px';
// Limite de pixels por canvas no Safari/iOS (4096 x 4096); acima disso a página sai em branco.
var MAXIMO_PIXELS_CANVAS = 16777216;
var TELA_PEQUENA = '(max-width: 768px)';
// Espaço lateral descontado da largura da página (menor no celular para a página ficar maior).
var MARGEM_LATERAL_PAGINA = 32;
var MARGEM_LATERAL_PAGINA_TELA_PEQUENA = 8;
// Zoom por pinça: acima do máximo a página é ampliada sem redesenhar, para poupar memória.
var ZOOM_MAXIMO = 3;
var ATRASO_REDESENHO_ZOOM_MS = 300;
/**
 * Densidade usada para desenhar a página na resolução física da tela (Retina, celulares)
 * multiplicada pelo zoom da pinça, limitada ao máximo de pixels suportado pelo navegador.
 */
var calcularDensidadePixels = function (largura, altura, zoom) {
    var densidadeTela = (window.devicePixelRatio || 1) * zoom;
    var densidadeMaxima = Math.sqrt(MAXIMO_PIXELS_CANVAS / (largura * altura));
    return Math.min(densidadeTela, densidadeMaxima);
};
// Arredonda em passos de 0,5 para não redesenhar a cada pequena variação da pinça.
var normalizarZoom = function (escala) { return Math.min(ZOOM_MAXIMO, Math.max(1, Math.ceil(escala * 2) / 2)); };
/**
 * Zoom aplicado pela pinça (visualViewport.scale). O navegador só amplia a imagem já desenhada;
 * com este valor as páginas visíveis são redesenhadas na nova escala ao fim do gesto.
 */
var useZoomDaPinca = function () {
    var _a = React.useState(function () { var _a, _b; return normalizarZoom((_b = (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.scale) !== null && _b !== void 0 ? _b : 1); }), zoom = _a[0], setZoom = _a[1];
    React.useEffect(function () {
        var visualViewport = window.visualViewport;
        if (!visualViewport) {
            return undefined;
        }
        var temporizador;
        var atualizarZoom = function () {
            window.clearTimeout(temporizador);
            temporizador = window.setTimeout(function () { return setZoom(normalizarZoom(visualViewport.scale)); }, ATRASO_REDESENHO_ZOOM_MS);
        };
        visualViewport.addEventListener('resize', atualizarZoom);
        return function () {
            window.clearTimeout(temporizador);
            visualViewport.removeEventListener('resize', atualizarZoom);
        };
    }, []);
    return zoom;
};
var ViewerContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: #525659;\n  padding: 16px 0;\n\n  @media ", " {\n    padding: 8px 0;\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: #525659;\n  padding: 16px 0;\n\n  @media ", " {\n    padding: 8px 0;\n  }\n"])), TELA_PEQUENA);
var CenteredArea = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n"])));
var PageWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n\n  @media ", " {\n    margin-bottom: 8px;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n\n  @media ", " {\n    margin-bottom: 8px;\n  }\n"])), TELA_PEQUENA);
var PageCanvas = styled.canvas(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  max-width: 100%;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n"], ["\n  max-width: 100%;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n"])));
var ProtectedPdfPage = function (_a) {
    var documento = _a.documento, numero = _a.numero, largura = _a.largura, zoom = _a.zoom, marcaDagua = _a.marcaDagua;
    var canvasRef = React.useRef(null);
    var zoomDesenhadoRef = React.useRef(1);
    var _b = useInView({ rootMargin: MARGEM_PRE_CARGA }), ref = _b.ref, inView = _b.inView;
    React.useEffect(function () {
        var canvas = canvasRef.current;
        // Página ampliada que saiu da tela é descartada: evita acumular canvases grandes (limite de memória do iOS).
        if (!inView && canvas && zoomDesenhadoRef.current > 1) {
            canvas.width = 0;
            canvas.height = 0;
            zoomDesenhadoRef.current = 1;
        }
        if (!inView || !largura) {
            return undefined;
        }
        var renderTask;
        var cancelado = false;
        var rascunho = document.createElement('canvas');
        var desenharPagina = function () { return __awaiter(void 0, void 0, void 0, function () {
            var page, escala, viewport, densidade, contextoRascunho, transform, canvasVisivel, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, documento.getPage(numero)];
                    case 1:
                        page = _a.sent();
                        escala = largura / page.getViewport({ scale: 1 }).width;
                        viewport = page.getViewport({ scale: escala });
                        if (cancelado) {
                            return [2 /*return*/];
                        }
                        densidade = calcularDensidadePixels(viewport.width, viewport.height, zoom);
                        rascunho.width = Math.floor(viewport.width * densidade);
                        rascunho.height = Math.floor(viewport.height * densidade);
                        contextoRascunho = rascunho.getContext('2d');
                        transform = densidade !== 1 ? [densidade, 0, 0, densidade, 0, 0] : undefined;
                        renderTask = page.render({ canvasContext: contextoRascunho, viewport: viewport, transform: transform });
                        return [4 /*yield*/, renderTask.promise];
                    case 2:
                        _a.sent();
                        canvasVisivel = canvasRef.current;
                        if (cancelado || !canvasVisivel) {
                            return [2 /*return*/];
                        }
                        desenharMarcaDagua(contextoRascunho, marcaDagua);
                        canvasVisivel.width = rascunho.width;
                        canvasVisivel.height = rascunho.height;
                        // O tamanho visual continua o da página, independente da densidade usada no desenho.
                        canvasVisivel.style.width = Math.floor(viewport.width) + "px";
                        canvasVisivel.style.height = Math.floor(viewport.height) + "px";
                        canvasVisivel.getContext('2d').drawImage(rascunho, 0, 0);
                        zoomDesenhadoRef.current = zoom;
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        if (!cancelado) {
                            console.error(error_1);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        // Libera a memória do canvas auxiliar (o Safari só devolve com o tamanho zerado).
                        rascunho.width = 0;
                        rascunho.height = 0;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        desenharPagina();
        return function () {
            cancelado = true;
            renderTask === null || renderTask === void 0 ? void 0 : renderTask.cancel();
        };
    }, [documento, numero, largura, zoom, inView, marcaDagua]);
    return (React.createElement(PageWrapper, { ref: ref, style: { minHeight: largura * PROPORCAO_PAGINA } },
        React.createElement(PageCanvas, { ref: canvasRef })));
};
export var ProtectedPdfViewer = function (_a) {
    var arquivoId = _a.arquivoId, endpoint = _a.endpoint, marcaDagua = _a.marcaDagua, onError = _a.onError;
    var containerRef = React.useRef(null);
    var _b = React.useState(), documento = _b[0], setDocumento = _b[1];
    var _c = React.useState(0), largura = _c[0], setLargura = _c[1];
    var zoom = useZoomDaPinca();
    React.useEffect(function () {
        var cancelado = false;
        var tarefa;
        var cancelamento = axios.CancelToken.source();
        // O PDF vem da API (mesma origem já liberada e com o token do jogador), nunca direto do storage.
        var carregarDocumento = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, pdf, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, axiosClient.get(endpoint !== null && endpoint !== void 0 ? endpoint : "arquivo/" + arquivoId, {
                                responseType: 'arraybuffer',
                                cancelToken: cancelamento.token,
                            })];
                    case 1:
                        response = _a.sent();
                        if (cancelado) {
                            return [2 /*return*/];
                        }
                        tarefa = pdfjsLib.getDocument({ data: new Uint8Array(response.data) });
                        return [4 /*yield*/, tarefa.promise];
                    case 2:
                        pdf = _a.sent();
                        if (!cancelado) {
                            setDocumento(pdf);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        if (!cancelado) {
                            console.error(error_2);
                            onError();
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        carregarDocumento();
        return function () {
            cancelado = true;
            cancelamento.cancel();
            tarefa === null || tarefa === void 0 ? void 0 : tarefa.destroy();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arquivoId, endpoint]);
    React.useEffect(function () {
        var atualizarLargura = function () {
            var _a, _b;
            var containerWidth = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
            var margemLateral = window.matchMedia(TELA_PEQUENA).matches
                ? MARGEM_LATERAL_PAGINA_TELA_PEQUENA
                : MARGEM_LATERAL_PAGINA;
            setLargura(Math.max(containerWidth - margemLateral, 0));
        };
        atualizarLargura();
        window.addEventListener('resize', atualizarLargura);
        return function () { return window.removeEventListener('resize', atualizarLargura); };
    }, [documento]);
    return (React.createElement(ViewerContainer, { ref: containerRef }, !documento ? (React.createElement(CenteredArea, null,
        React.createElement(ActivityIndicator, { type: "spinner" }))) : (Array.from({ length: documento.numPages }).map(function (_, indice) { return (React.createElement(ProtectedPdfPage, { key: indice, documento: documento, numero: indice + 1, largura: largura, zoom: zoom, marcaDagua: marcaDagua })); }))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
